var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { KeyboardArrowDown } from '@mui/icons-material';
import { Box, IconButton, MenuItem, Select, TextField, Typography, useMediaQuery } from '@mui/material';
import { t } from 'i18next';
import { useEffect, useMemo, useState } from 'react';
import { v4 } from 'uuid';
import { customersResponseListURL, getSuggestionsURL, updateSuggestionURL, upsertSuggestionsURL } from '../../../../api/url';
import { EditIcon, TrashIconNew } from '../../../../assets/customIcons';
import { EditableDataGrid } from '../../../../builderPackage/components/editableDataGrid/editableDataGrid';
import { MuiButton, MuiStack } from '../../../../components';
import { MuiLoaderButton } from '../../../../components/atoms/loaderButton';
import { LOCAL_STORAGE_KEYS } from '../../../../constants';
import { setSavedTaskDetailsCount, setTaskDetailsDataSaved, showNotification } from '../../../../redux/commonSlice';
import { createAPI, getByIdAPI, getListAPI, setReducerState } from '../../../../redux/crudSlice';
import { useAppDispatch } from '../../../../store/hooks';
import { getLocalStorageItem } from '../../../../utils/storageHelper';
import { JobCardKeys } from '../../../jobCardDetails/services/entity';
var selectSx = {
    minWidth: 180,
    '&:before': {
        display: 'none'
    },
    '&:after': {
        display: 'none'
    }
};
var textFieldSx = {
    '& .MuiOutlinedInput-root': {
        borderRadius: 2
    }
};
var AdvisorSuggestions = function (_ref) {
    var _a = _ref.isDisabled, isDisabled = _a === void 0 ? false : _a, onSave = _ref.onSave, _b = _ref.documentId, documentId = _b === void 0 ? null : _b, _c = _ref.installBaseId, installBaseId = _c === void 0 ? null : _c, _d = _ref.documentType, documentType = _d === void 0 ? 'Estimate' : _d;
    var _e = useState([]), suggestions = _e[0], setSuggestions = _e[1];
    var _f = useState(false), showTextArea = _f[0], setShowTextArea = _f[1];
    var _g = useState(''), newSuggestionText = _g[0], setNewSuggestionText = _g[1];
    var _h = useState(''), newSuggestionError = _h[0], setNewSuggestionError = _h[1];
    var _j = useState(null), editingId = _j[0], setEditingId = _j[1];
    var _k = useState(''), editingText = _k[0], setEditingText = _k[1];
    var _l = useState(''), editingError = _l[0], setEditingError = _l[1];
    var _m = useState([]), customerResponses = _m[0], setCustomerResponses = _m[1];
    var _o = useState(false), isLoading = _o[0], setIsLoading = _o[1];
    var isMobile = useMediaQuery(function (theme) { return theme.breakpoints.only('xs'); });
    var SUGGESTIONS_DATA = getLocalStorageItem(LOCAL_STORAGE_KEYS.SUGGESTIONS_REQUIRED_COUNT);
    var MaxAllowedSuggestion = SUGGESTIONS_DATA ? Number(SUGGESTIONS_DATA === null || SUGGESTIONS_DATA === void 0 ? void 0 : SUGGESTIONS_DATA.Value) : 0;
    var docType = documentType === 'ServiceEstimate' ? 'Estimate' : documentType;
    var _p = useState(false), isError = _p[0], setIsError = _p[1];
    var dispatch = useAppDispatch();
    var customersResponseAPICall = function (params) { return __awaiter(void 0, void 0, void 0, function () {
        var _res$payload, _a, key, _b, request, _c, url, res;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _a = params.key, key = _a === void 0 ? 'CustomersResponseData' : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? customersResponseListURL : _c;
                    return [4 /*yield*/, dispatch(getByIdAPI({
                            key: key,
                            url: url,
                            request: {
                                Remarks: request.Remarks
                            }
                        }))];
                case 1:
                    res = _d.sent();
                    return [2 /*return*/, res === null || res === void 0 || (_res$payload = res.payload) === null || _res$payload === void 0 ? void 0 : _res$payload.value];
            }
        });
    }); };
    var activeSuggestions = useMemo(function () {
        return (suggestions === null || suggestions === void 0 ? void 0 : suggestions.filter(function (item) { return !item.IsDeleted; })) || [];
    }, [suggestions]);
    var fetchSuggestionsAPICall = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _res$payload2, _res$payload3, res, savedSuggestions, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!documentId && !installBaseId)
                        return [2 /*return*/];
                    setIsLoading(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 5, 6, 7]);
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: 'savedSuggestions',
                            url: getSuggestionsURL,
                            request: {
                                InstallBaseId: installBaseId,
                                DocumentId: documentId,
                                DocumentType: docType
                            }
                        }))];
                case 2:
                    res = _a.sent();
                    if (!(res !== null && res !== void 0 && (_res$payload2 = res.payload) !== null && _res$payload2 !== void 0 && (_res$payload2 = _res$payload2.value) !== null && _res$payload2 !== void 0 && _res$payload2.success && res !== null && res !== void 0 && (_res$payload3 = res.payload) !== null && _res$payload3 !== void 0 && (_res$payload3 = _res$payload3.value) !== null && _res$payload3 !== void 0 && _res$payload3.data)) return [3 /*break*/, 4];
                    savedSuggestions = res.payload.value.data.map(function (item) { return _objectSpread(_objectSpread({}, item), {}, {
                        id: item.id || item.SuggestionId,
                        CustomersResponseId: item.CustomersResponseId || '',
                        SuggestionId: item.SuggestionId
                    }); });
                    return [4 /*yield*/, dispatch(setSavedTaskDetailsCount({
                            advisorSuggestionsCount: savedSuggestions === null || savedSuggestions === void 0 ? void 0 : savedSuggestions.length
                        }))];
                case 3:
                    _a.sent();
                    setSuggestions(savedSuggestions);
                    _a.label = 4;
                case 4: return [3 /*break*/, 7];
                case 5:
                    error_1 = _a.sent();
                    console.error('Error fetching suggestions:', error_1);
                    return [3 /*break*/, 7];
                case 6:
                    setIsLoading(false);
                    return [7 /*endfinally*/];
                case 7: return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        var fetchCustomerResponses = function () { return __awaiter(void 0, void 0, void 0, function () {
            var responses;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, customersResponseAPICall({})];
                    case 1:
                        responses = _a.sent();
                        setCustomerResponses((responses === null || responses === void 0 ? void 0 : responses.data) || []);
                        return [2 /*return*/];
                }
            });
        }); };
        fetchCustomerResponses();
        if (documentId && installBaseId)
            fetchSuggestionsAPICall();
    }, [documentId, installBaseId]);
    var handleAddClick = function () {
        if (suggestions.length >= MaxAllowedSuggestion) {
            dispatch(showNotification({
                isOpen: true,
                message: t("Adding more suggestions is not allowed. The maximum allowed suggestions is ".concat(MaxAllowedSuggestion, ", as per configuration.")),
                type: 'error'
            }));
            return;
        }
        setShowTextArea(true);
        setNewSuggestionText('');
    };
    var handleCancel = function () {
        setShowTextArea(false);
        setNewSuggestionText('');
        setNewSuggestionError('');
    };
    var handleBlurSuggestionField = function () {
        if (!newSuggestionText) {
            handleCancel();
            return;
        }
        if (newSuggestionText.length > 1000) {
            setNewSuggestionError('Suggestion cannot exceed 1000 characters.');
            return;
        }
        var defaultResponse = (customerResponses === null || customerResponses === void 0 ? void 0 : customerResponses.find(function (resp) { return resp.Name === 'Refused by Customer'; })) || (customerResponses === null || customerResponses === void 0 ? void 0 : customerResponses[0]);
        var newSuggestion = {
            id: v4(),
            SuggestionContent: newSuggestionText.trim(),
            CustomersResponseId: (defaultResponse === null || defaultResponse === void 0 ? void 0 : defaultResponse.id) || '',
            CustomersResponses: defaultResponse === null || defaultResponse === void 0 ? void 0 : defaultResponse.Name,
            IsActive: true,
            IsDeleted: false,
            UserDeleted: false,
            isNewRow: true
        };
        var updatedSuggestions = __spreadArray(__spreadArray([], suggestions, true), [newSuggestion], false);
        setSuggestions(updatedSuggestions);
        setNewSuggestionText('');
        setNewSuggestionError('');
        setShowTextArea(false);
        onSave === null || onSave === void 0 || onSave(updatedSuggestions);
    };
    var handleDelete = function (id) { return __awaiter(void 0, void 0, void 0, function () {
        var _updatedSuggestions$f, updatedSuggestions;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    updatedSuggestions = suggestions.filter(function (it) { return it.id !== id; });
                    return [4 /*yield*/, dispatch(createAPI({
                            key: 'delete',
                            url: updateSuggestionURL,
                            request: {
                                IsDeleted: true,
                                IsActive: false,
                                SuggestionId: id
                            }
                        }))];
                case 1:
                    _a.sent();
                    dispatch(setSavedTaskDetailsCount({
                        advisorSuggestionsCount: (updatedSuggestions === null || updatedSuggestions === void 0 || (_updatedSuggestions$f = updatedSuggestions.filter(function (item) { return !item.IsDeleted; })) === null || _updatedSuggestions$f === void 0 ? void 0 : _updatedSuggestions$f.length) || 0
                    }));
                    setSuggestions(updatedSuggestions);
                    onSave === null || onSave === void 0 || onSave(updatedSuggestions);
                    return [2 /*return*/];
            }
        });
    }); };
    var handleEdit = function (suggestion) {
        setEditingId(suggestion.id);
        setEditingText((suggestion === null || suggestion === void 0 ? void 0 : suggestion.SuggestionContent) || '');
        setEditingError('');
    };
    var handleSaveEdit = function (id) {
        if (!editingText.trim()) {
            setEditingId(null);
            setEditingText('');
            setEditingError('');
            return;
        }
        if (editingText.length > 1000) {
            setEditingError('Suggestion cannot exceed 1000 characters.');
            return;
        }
        var updatedSuggestions = suggestions.map(function (it) { return it.id === id ? _objectSpread(_objectSpread({}, it), {}, {
            SuggestionContent: editingText.trim()
        }) : it; });
        setSuggestions(updatedSuggestions);
        setEditingId(null);
        setEditingText('');
        setEditingError('');
        onSave === null || onSave === void 0 || onSave(updatedSuggestions);
    };
    var handleSuggestionsChange = function (id, value) {
        var updatedSuggestions = suggestions.map(function (it) { return it.id === id ? _objectSpread(_objectSpread({}, it), {}, {
            CustomersResponseId: value
        }) : it; });
        setSuggestions(updatedSuggestions);
        onSave === null || onSave === void 0 || onSave(updatedSuggestions);
    };
    var handleSectionSave = function () { return __awaiter(void 0, void 0, void 0, function () {
        var activeFutureAdvices, _i, activeFutureAdvices_1, item, _res$payload4, _res$payload5, _res$payload6, payload, res, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (suggestions.length === 0)
                        return [2 /*return*/];
                    activeFutureAdvices = suggestions.filter(function (item) { return !(item !== null && item !== void 0 && item.IsDeleted); });
                    for (_i = 0, activeFutureAdvices_1 = activeFutureAdvices; _i < activeFutureAdvices_1.length; _i++) {
                        item = activeFutureAdvices_1[_i];
                        if (!item.SuggestionContent) {
                            dispatch(showNotification({
                                isOpen: true,
                                message: t('You’ve added a suggestion line. Please provide the details or remove the line to proceed'),
                                type: 'error'
                            }));
                            return [2 /*return*/];
                        }
                    }
                    setIsLoading(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    payload = {
                        SuggestionList: suggestions.map(function (s) { return _objectSpread(_objectSpread({}, s), {}, {
                            SuggestionId: s.SuggestionId || s.id
                        }); }),
                        InstallBaseId: installBaseId,
                        DocumentId: documentId,
                        DocumentType: docType
                    };
                    return [4 /*yield*/, dispatch(createAPI({
                            key: 'upsertSuggestions',
                            url: upsertSuggestionsURL,
                            request: payload
                        }))];
                case 2:
                    res = _a.sent();
                    dispatch(showNotification({
                        isOpen: true,
                        message: t(res !== null && res !== void 0 && (_res$payload4 = res.payload) !== null && _res$payload4 !== void 0 && (_res$payload4 = _res$payload4.value) !== null && _res$payload4 !== void 0 && _res$payload4.success ? 'Suggestions saved successfully' : 'Failed to save suggestions'),
                        type: res !== null && res !== void 0 && (_res$payload5 = res.payload) !== null && _res$payload5 !== void 0 && (_res$payload5 = _res$payload5.value) !== null && _res$payload5 !== void 0 && _res$payload5.success ? 'success' : 'error'
                    }));
                    if (res !== null && res !== void 0 && (_res$payload6 = res.payload) !== null && _res$payload6 !== void 0 && (_res$payload6 = _res$payload6.value) !== null && _res$payload6 !== void 0 && _res$payload6.success)
                        fetchSuggestionsAPICall();
                    return [3 /*break*/, 5];
                case 3:
                    error_2 = _a.sent();
                    console.error('Error saving suggestions:', error_2);
                    dispatch(showNotification({
                        isOpen: true,
                        message: t('Failed to save suggestions'),
                        type: 'error'
                    }));
                    return [3 /*break*/, 5];
                case 4:
                    setIsLoading(false);
                    dispatch(setTaskDetailsDataSaved(true));
                    dispatch(setSavedTaskDetailsCount({
                        advisorSuggestionsCount: suggestions === null || suggestions === void 0 ? void 0 : suggestions.length
                    }));
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var columns = [{
            type: 'string',
            field: 'SuggestionContent',
            headerName: 'Suggestion',
            flex: 1,
            minWidth: 300,
            editable: !isDisabled,
            placeholder: 'Enter remarks'
        }, {
            type: 'searchSelect',
            field: 'CustomersResponseId',
            headerName: 'Customer response',
            minWidth: 200,
            editable: !isDisabled,
            valueOptions: customerResponses || [],
            valueGetter: function (val, row) {
                var _row$CustomersRespons, _row$CustomersRespons2;
                return {
                    Name: (_row$CustomersRespons = row === null || row === void 0 ? void 0 : row.CustomersResponses) !== null && _row$CustomersRespons !== void 0 ? _row$CustomersRespons : '',
                    id: (_row$CustomersRespons2 = row === null || row === void 0 ? void 0 : row.CustomersResponseId) !== null && _row$CustomersRespons2 !== void 0 ? _row$CustomersRespons2 : null
                };
            },
            valueSetter: function (value, row) {
                var _value$id, _value$Name;
                return _objectSpread(_objectSpread({}, row), {}, {
                    CustomersResponseId: (_value$id = value === null || value === void 0 ? void 0 : value.id) !== null && _value$id !== void 0 ? _value$id : null,
                    CustomersResponses: (_value$Name = value === null || value === void 0 ? void 0 : value.Name) !== null && _value$Name !== void 0 ? _value$Name : ''
                });
            },
            getOptionLabel: function (option) { return (option === null || option === void 0 ? void 0 : option.Name) || ''; },
            valueFormatter: function (value) { return (value === null || value === void 0 ? void 0 : value.Name) || ''; }
        }];
    var handleToolbarButtonClick = function (e, params) { return __awaiter(void 0, void 0, void 0, function () {
        var _params$api, _updatedSuggestions$f2, selectedRows_1, updatedSuggestions, defaultResponse, newRows;
        return __generator(this, function (_a) {
            if (e.currentTarget.id === 'delete') {
                selectedRows_1 = params === null || params === void 0 || (_params$api = params.api) === null || _params$api === void 0 || (_params$api = _params$api.current) === null || _params$api === void 0 ? void 0 : _params$api.getSelectedRows();
                updatedSuggestions = suggestions.map(function (item) {
                    var isSelected = selectedRows_1 === null || selectedRows_1 === void 0 ? void 0 : selectedRows_1.has(item.id);
                    if (isSelected) {
                        if (item.SuggestionId) {
                            dispatch(createAPI({
                                key: 'delete',
                                url: updateSuggestionURL,
                                request: {
                                    IsDeleted: true,
                                    IsActive: false,
                                    SuggestionId: item.SuggestionId
                                }
                            }));
                        }
                        return _objectSpread(_objectSpread({}, item), {}, {
                            IsDeleted: true,
                            IsActive: false,
                            UserDeleted: true
                        });
                    }
                    return item;
                });
                console.log("updatedSuggestions", updatedSuggestions);
                dispatch(setSavedTaskDetailsCount({
                    advisorSuggestionsCount: (updatedSuggestions === null || updatedSuggestions === void 0 || (_updatedSuggestions$f2 = updatedSuggestions.filter(function (item) { return !item.IsDeleted; })) === null || _updatedSuggestions$f2 === void 0 ? void 0 : _updatedSuggestions$f2.length) || 0
                }));
                setSuggestions(updatedSuggestions);
                onSave === null || onSave === void 0 || onSave(updatedSuggestions);
                return [2 /*return*/, false]; // Return false to prevent default behavior`
            }
            if (e.currentTarget.id === 'add') {
                defaultResponse = (customerResponses === null || customerResponses === void 0 ? void 0 : customerResponses.find(function (resp) { return resp.Name === 'Refused by Customer'; })) || (customerResponses === null || customerResponses === void 0 ? void 0 : customerResponses[0]);
                newRows = __spreadArray(__spreadArray([], suggestions, true), [{
                        id: v4(),
                        isNewRow: true,
                        IsActive: true,
                        IsDeleted: false,
                        UserDeleted: false,
                        CustomersResponseId: (defaultResponse === null || defaultResponse === void 0 ? void 0 : defaultResponse.id) || null,
                        CustomersResponses: (defaultResponse === null || defaultResponse === void 0 ? void 0 : defaultResponse.Name) || ''
                    }], false);
                if (suggestions.filter(function (item) { return !item.IsDeleted; }).length >= MaxAllowedSuggestion) {
                    dispatch(showNotification({
                        isOpen: true,
                        message: t("Adding more suggestions is not allowed. The maximum allowed suggestions is ".concat(MaxAllowedSuggestion, ", as per configuration.")),
                        type: 'error'
                    }));
                    return [2 /*return*/, false];
                }
                setSuggestions(newRows);
                onSave === null || onSave === void 0 || onSave(newRows);
                return [2 /*return*/, false];
            }
            return [2 /*return*/, true];
        });
    }); };
    var handleDisableSaveButton = function (value) {
        setIsError(value);
        dispatch(setReducerState({
            key: JobCardKeys.DisableSubmit,
            value: value
        }));
    };
    return /*#__PURE__*/ React.createElement(Box, {
        sx: {
            width: '100%'
        }
    }, isMobile ? /*#__PURE__*/ React.createElement(MuiStack, {
        direction: "column",
        spacing: 2,
        width: "100%",
        padding: 2,
        sx: {
            background: '#fff',
            borderRadius: '8px'
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        display: docType !== "JobCard" ? 'none' : undefined,
        fontWeight: 'strong'
    }, t('Suggestions')), !showTextArea && !isDisabled && /*#__PURE__*/ React.createElement(MuiStack, {
        direction: "row",
        justifyContent: "flex-end"
    }, /*#__PURE__*/ React.createElement(MuiButton, {
        variant: "text",
        name: "+ ".concat(t('Add')),
        size: "small",
        onClick: handleAddClick,
        id: "add-suggestion-btn"
    })), suggestions.map(function (suggestion) { /*#__PURE__*/ return React.createElement(MuiStack, {
        key: suggestion.id,
        direction: {
            xs: 'column',
            sm: 'row'
        },
        alignItems: {
            xs: 'flex-start',
            sm: 'center'
        },
        justifyContent: "space-between",
        spacing: 1
    }, editingId === suggestion.id && !isDisabled ? /*#__PURE__*/ React.createElement(TextField, {
        fullWidth: true,
        multiline: true,
        rows: 2,
        size: "small",
        autoFocus: true,
        value: editingText,
        onChange: function (e) {
            var value = e.target.value;
            setEditingText(value);
            if (value.length > 1000) {
                setEditingError('Suggestion cannot exceed 1000 characters.');
            }
            else {
                setEditingError('');
            }
        },
        onBlur: function () { return handleSaveEdit(suggestion.id); },
        onKeyDown: function (e) {
            if (e.key === 'Escape') {
                setEditingId(null);
                setEditingText('');
                setEditingError('');
            }
        },
        error: !!editingError,
        helperText: editingError || "".concat(editingText.length, "/1000 characters"),
        sx: {
            flex: 1
        }
    }) : /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Typography, {
        variant: "body1",
        sx: {
            flex: 1,
            width: {
                xs: '100%',
                sm: 'auto'
            },
            wordBreak: 'break-word'
        }
    }, suggestion.SuggestionContent), /*#__PURE__*/ React.createElement(MuiStack, {
        direction: "row",
        alignItems: "center",
        justifyContent: "space-between",
        spacing: 1,
        width: {
            xs: '100%',
            sm: 'auto'
        }
    }, /*#__PURE__*/ React.createElement(Select, {
        IconComponent: KeyboardArrowDown,
        value: suggestion.CustomersResponseId,
        onChange: function (e) { return handleSuggestionsChange(suggestion.id, e.target.value); },
        size: "small",
        variant: "standard",
        disableUnderline: true,
        disabled: isDisabled,
        sx: selectSx
    }, customerResponses.map(function (option) { /*#__PURE__*/ return React.createElement(MenuItem, {
        key: option.id,
        id: "customer-response-".concat(option.Name),
        value: option.id
    }, option.Name); })), !isDisabled && /*#__PURE__*/ React.createElement(MuiStack, {
        direction: "row",
        alignItems: "center",
        spacing: 1
    }, /*#__PURE__*/ React.createElement(IconButton, {
        onClick: function () { return handleEdit(suggestion); },
        size: "small"
    }, /*#__PURE__*/ React.createElement(EditIcon, null)), /*#__PURE__*/ React.createElement(IconButton, {
        onClick: function () { return handleDelete(suggestion.id); },
        size: "small"
    }, /*#__PURE__*/ React.createElement(TrashIconNew, null)))))); }), showTextArea && !isDisabled && /*#__PURE__*/ React.createElement(TextField, {
        fullWidth: true,
        multiline: true,
        rows: 4,
        autoFocus: true,
        placeholder: t('Enter a description...'),
        value: newSuggestionText,
        onChange: function (e) {
            var value = e.target.value;
            setNewSuggestionText(value);
            if (value.length > 1000) {
                setNewSuggestionError('Suggestion cannot exceed 1000 characters.');
            }
            else {
                setNewSuggestionError('');
            }
        },
        onBlur: handleBlurSuggestionField,
        onKeyDown: function (e) {
            if (e.key === 'Escape')
                handleCancel();
        },
        error: !!newSuggestionError,
        helperText: newSuggestionError || "".concat(newSuggestionText.length, "/1000 characters"),
        sx: textFieldSx
    }), suggestions.length === 0 && !showTextArea && /*#__PURE__*/ React.createElement(MuiStack, {
        alignItems: "center",
        justifyContent: "center",
        padding: 4
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "body2",
        color: "textSecondary"
    }, t('No suggestions added.')))) : /*#__PURE__*/ React.createElement(EditableDataGrid, {
        columns: columns,
        rows: activeSuggestions,
        onChange: function (e, updatedRows) {
            console.log("updatedRows", updatedRows);
            if (updatedRows) {
                setSuggestions(updatedRows);
                onSave === null || onSave === void 0 || onSave(updatedRows);
            }
        },
        dataGridHeader: docType === "JobCard" && !isDisabled ? "Suggestions" : null,
        isCollapsible: false,
        disableDeleteRow: isDisabled,
        disableAddRow: isDisabled,
        dataGridProps: {
            checkboxSelection: !isDisabled,
            disableRowSelectionOnClick: true,
            hideFooter: true,
            slotProps: {
                toolbar: {
                    chipLabel: docType === 'JobCard' && !isDisabled ? activeSuggestions === null || activeSuggestions === void 0 ? void 0 : activeSuggestions.length : null
                }
            }
        },
        validationModel: {
            SuggestionContent: function (value, row) {
                if (value.length > 1000) {
                    handleDisableSaveButton(true);
                    return 'Suggestion cannot exceed 1000 characters.';
                }
                handleDisableSaveButton(false);
                return '';
            },
            CustomersResponseId: function (value, row) {
                if (!value) {
                    handleDisableSaveButton(true);
                    return 'You can not clear the response since it is a mandatory field.';
                }
                handleDisableSaveButton(false);
                return '';
            }
        },
        onToolbarButtonClick: handleToolbarButtonClick
    }), docType !== "JobCard" && suggestions.length > 0 && !isDisabled && !showTextArea && /*#__PURE__*/ React.createElement(MuiStack, {
        direction: "row",
        justifyContent: "flex-end",
        paddingTop: 2,
        display: docType === 'JobCard' ? 'none' : undefined
    }, /*#__PURE__*/ React.createElement(MuiLoaderButton, {
        variant: "outlined",
        name: t('Save'),
        size: "medium",
        loading: isLoading,
        onClick: handleSectionSave,
        disabled: suggestions.length === 0 || isError || isDisabled,
        id: "section-save-suggestion-btn"
    })));
};
export default AdvisorSuggestions;
